import { Type } from 'class-transformer';

import { Folder } from './site-content/folder.model';
import { FormInstance } from './site-content/form-instance.model';
import { FolderPermissionExpression } from './site-metadata/folder-permission-expression.model';
import { FolderRoleMember } from './site-metadata/folder-role-member.model';

export class FolderFormInstanceTree {
    // Key.
    public id: number = 0;
    public type: string;

    public name: string;
    public description: string;

    // references
    public parentFolderId: number;
    public dataCollectionId: number;
    public referencedFormInstanceId: string;
    public isReferenced: boolean;
    public isReferencedCount: number;

    public helpTextFormat: string;
    public helpText: string;
    public setName: string;

    public canBuildFolders: boolean;
    public canBuildFormInstances: boolean;
    public canBuildForms: boolean;
    public canBuildWorkflows: boolean;
    public canBuildRoles: boolean;
    public canDelete: boolean;
    public canEdit: boolean;
    public canGrant: boolean;
    public canView: boolean;

    // new for simple permissions
    public canCreateForm: boolean;
    public canDeleteForm: boolean;
    public canCreateFolder: boolean;
    public isTransparentFolder: boolean;

    // Helpers
    public qualifiedId(): string{
        return `${this.type}_${this.id}`
    }

    // Collections.
    @Type(() => FolderFormInstanceTree)
    public childFolders: FolderFormInstanceTree[];

    @Type(() => FolderFormInstanceTree)
    public childFormInstances: FolderFormInstanceTree[];

    // Define properties related to folder permissions.
    public permissionExpressionIsLocked: boolean;
    @Type(() => FolderPermissionExpression)
    public folderPermissionExpression: FolderPermissionExpression = null;

    public folderPermissionExpressionTag: string;
    public folderPermissionExpressionName: string;
    public folderPermissionExpressionId: number;

    @Type(() => FolderRoleMember)
    public folderRoleMembers: FolderRoleMember[];
    // End properties related to folder permissions.

    // Methods to convert to an instance of Folder or FormInstance.
    public toFolder(): Folder {
        var folder: Folder = new Folder();

        folder.id = this.id;

        folder.name = this.name;
        folder.description = this.description;

        folder.dataCollectionId = this.dataCollectionId;
        folder.parentFolderId = this.parentFolderId;

        folder.helpTextFormat = this.helpTextFormat;
        folder.helpText = this.helpText;
        folder.canBuildFolders = this.canBuildFolders;
        folder.canBuildFormInstances = this.canBuildFormInstances;

        //simplified permission model
        folder.canCreateFolder = this.canCreateFolder;
        folder.canCreateForm = this.canCreateForm;
        folder.isTransparentFolder = this.isTransparentFolder;

        folder.canView = this.canView;
        folder.canEdit = this.canEdit;
        folder.canDelete = this.canDelete;
        folder.canGrant = this.canGrant;

        return (folder);
    }

    public toFormInstance(): FormInstance {
        var formInstance: FormInstance = new FormInstance();

        formInstance.id = this.id;
        formInstance.name = this.name;
        formInstance.dataCollectionId = this.dataCollectionId;
        formInstance.folderId = this.parentFolderId;
        formInstance.canView = this.canView;
        formInstance.canEdit = this.canEdit;
        formInstance.canDelete = this.canDelete;
        formInstance.canGrant = this.canGrant;

        return (formInstance);
    }

    // Methods to apply updates from a Folder or FormInstance.
    public updateFromFolder(folder: Folder): void {

    }

    public updateFormFormInstance(formInstance: FormInstance): void {

    }

    // Path-related methods.
    //public deriveFolderPath(rootFolderParam: Folder, folderId: number): string {
    public deriveFolderPath(tree: FolderFormInstanceTree, folderId: number): string {
        let folderPath: string = null;

        //let ancestorFolders: Folder[] = [];
        let ancestorFolders: FolderFormInstanceTree[] = [];

        //if (rootFolder != null) {
        if (tree != null) {
            //let foundFolder: Folder = FolderFormInstanceTree.findFolder(folderId, rootFolder, ancestorFolders);
            let foundFolder: FolderFormInstanceTree = FolderFormInstanceTree.findFolder(folderId, tree, ancestorFolders);

            if (foundFolder != null) {
                folderPath = "/";

                for (let iAncestor: number = 0; iAncestor < ancestorFolders.length; iAncestor++) {
                    //let ancestorFolder: Folder = ancestorFolders[iAncestor];
                    let ancestorFolder: FolderFormInstanceTree = ancestorFolders[iAncestor];

                    folderPath += ancestorFolder.name + "/";
                } // for

                folderPath += foundFolder.name;
            } // if
        } // if

        return (folderPath);
    }

    //private static findFolder(folderId: number, parentFolder: Folder, ancestorFolders: Folder[]): Folder {
    private static findFolder(folderId: number, parentFolder: FolderFormInstanceTree, ancestorFolders: FolderFormInstanceTree[]): FolderFormInstanceTree {
        //let foundFolder: Folder = null;
        let foundFolder: FolderFormInstanceTree = null;

        if (parentFolder.childFolders != null) {
            for (let iChildIndex: number = 0; iChildIndex < parentFolder.childFolders.length; iChildIndex++) {
                //let childFolder: Folder = parentFolder.childFolders[iChildIndex];
                let childFolder: FolderFormInstanceTree = parentFolder.childFolders[iChildIndex];

                if (childFolder.id == folderId) {
                    foundFolder = childFolder;

                    break;
                } else {
                    ancestorFolders.push(childFolder);

                    foundFolder = FolderFormInstanceTree.findFolder(folderId, childFolder, ancestorFolders);

                    if (foundFolder != null) {
                        break;
                    } else {
                        ancestorFolders.pop();
                    } // if-else
                } // if-else
            } // for 
        } // if

        return (foundFolder);
    }

}
